/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TickerBidderDto } from '../../models/ticker-bidder-dto';

export interface GetTickerBidders$Params {
  ids: string;
  'X-API-Version'?: string;
}

export function getTickerBidders(http: HttpClient, rootUrl: string, params: GetTickerBidders$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TickerBidderDto>>> {
  const rb = new RequestBuilder(rootUrl, getTickerBidders.PATH, 'get');
  if (params) {
    rb.path('ids', params.ids, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TickerBidderDto>>;
    })
  );
}

getTickerBidders.PATH = '/api/ticker/bidders/{ids}';
